// environment.js
const isProduction = process.env.NODE_ENV === 'production';
const websiteName = 'Meeako';

module.exports = { isProduction, websiteName };